import { PersonIcon, Star } from 'assets/icons';
import Badge from 'components/badge/badge';
import useText from 'hooks/useText';
import ListIcon from './ListIcon';
import { HOVER_REVEAL_CLASS, HOVER_ROW_CLASS } from 'utils/surfaceClasses';

// A contact who recommends Jobbiz around them.
export const AmbassadorBadge = () => {
  const { text } = useText('record');
  return (
    <Badge type="AMBER">
      <Star wh={12} color="currentColor" />
      {text('ambassador')}
    </Badge>
  );
};

/**
 * A person of a record: a person icon in a frame (as a company of « Entreprises
 * du groupe »), their name and badges,
 * then what they are (`detail`: their position, their access, their phone,
 * their e-mail). A pending invitation shows on the right, before `actions`
 * (invite, resend an invitation); `hoverActions` only show while the row is
 * hovered (remove from the company). The row opens their page (`onOpen`).
 */
const ContactRow = ({ person, detail, onOpen, actions, hoverActions }) => {
  const { text } = useText('record');
  const name = [person.firstname, person.lastname].filter(Boolean).join(' ');
  return (
    <div className={`flex items-center gap-2 border-b border-gray-100 last:border-0 ${HOVER_ROW_CLASS}`}>
      <button
        type="button"
        disabled={!onOpen}
        onClick={onOpen}
        className="-ml-2 flex min-w-0 flex-1 items-center gap-3 rounded-lg px-2 py-2.5 text-left transition-colors enabled:hover:bg-gray-50"
      >
        <ListIcon icon={PersonIcon} />
        <span className="min-w-0">
          <span className="flex items-center gap-2">
            <span className="truncate text-sm font-medium text-gray-900">{name}</span>
            {person.leadStatus === 'ambassadeur' && <AmbassadorBadge />}
          </span>
          {detail && <span className="block truncate text-xs text-gray-600">{detail}</span>}
        </span>
        {person.account === 'pending' && (
          <span className="ml-auto shrink-0">
            <Badge type="OUTLINE">{text('pending')}</Badge>
          </span>
        )}
      </button>
      {actions}
      {hoverActions && <span className={`flex shrink-0 gap-1 ${HOVER_REVEAL_CLASS}`}>{hoverActions}</span>}
    </div>
  );
};

export default ContactRow;
